var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _vm.isOn()
        ? _c(
            "v-app-bar",
            {
              staticClass: "headerContainer",
              attrs: { app: "", color: "#34417C", dark: "" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-center justify-space-between header"
                },
                [
                  _c(
                    "div",
                    [
                      _c("v-img", {
                        attrs: {
                          alt: "Vuetify Logo",
                          contain: "",
                          src: require("./assets/img/logo.png"),
                          width: "126"
                        },
                        on: { click: _vm.goHome }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "right-menu" },
                    [
                      _vm.profile.name !== undefined
                        ? _c("div", { staticClass: "avatar" }, [
                            _c("span", [_vm._v(_vm._s(_vm.profile.name) + " ")])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "logout",
                          attrs: { color: "transparent", elevation: "0" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.logout.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _c("v-img", {
                            attrs: {
                              "max-width": "32",
                              src: require("./assets/img/icons/logout.png")
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-main",
        { staticClass: "mainBackColor", attrs: { "max-width": "1440px" } },
        [
          _c(
            "transition",
            { attrs: { name: _vm.transitionName, mode: "out-in" } },
            [_c("router-view", { key: _vm.$route.fullPath })],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("diary-date-validator"),
      _vm._v(" "),
      _c("reload-required")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 197
// module chunks = 1